import { Button, InputAdornment, Stack, TextField } from '@mui/material';
import { debounce, isString } from 'lodash';
import { useCallback, useState } from 'react';
import { Download, Search, Sliders } from 'react-feather';
import { useSearchParams } from 'react-router-dom';
import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
import IconFeather from 'src/components/common/Icon';
import PopupExportPeople from 'src/features/PeopleProfiles/PopupExportPeople';
import { useQueryParams } from 'src/hooks/useQueryParam';
import { FormType, useFormSearch } from 'src/zustand/useFormSearch';

const FilterPeopleProfile = () => {
  const query = useQueryParams();
  const [openExport, setOpenExport] = useState(false);
  const { handleOpenSearch } = useFormSearch((state) => state);
  const [, setSearchParams] = useSearchParams();

  const onChangeSearch = useCallback(
    debounce(async (e) => {
      setSearchParams((searchParams) => {
        searchParams.set('name', String(e.target.value));
        searchParams.set('offset', '0');
        return searchParams;
      });
    }, 1000),
    [query],
  );

  return (
    <Stack direction="row" spacing={3}>
      <Stack width="70%">
        <TextField
          sx={{ flex: 1 }}
          placeholder="People Name"
          size="small"
          fullWidth
          defaultValue={query?.name && isString(query?.name) ? query?.name : ''}
          onChange={onChangeSearch}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconFeather icon={<Search />} muiProps={{ color: 'disabled' }} />
              </InputAdornment>
            ),
          }}
        />
      </Stack>
      <Stack width="30%" justifyContent="flex-start" direction="row" spacing={1}>
        <Button
          onClick={() => {
            handleOpenSearch(FormType.SearchPeople);
          }}
          color="primary"
          startIcon={<IconFeather muiProps={{ fontSize: 'small' }} icon={<Sliders />} />}
          variant="outlined"
          sx={{ width: 'fit-content' }}
        >
          Advanced Filter
        </Button>
        <ButtonWithLoading
          onClick={() => {
            setOpenExport(true);
          }}
          color="primary"
          startIcon={<IconFeather muiProps={{ fontSize: 'small' }} icon={<Download />} />}
          variant="outlined"
          sx={{ width: 'fit-content' }}
        >
          EXPORT AS
        </ButtonWithLoading>
      </Stack>
      <PopupExportPeople open={openExport} handleClose={() => setOpenExport(false)} />
    </Stack>
  );
};

export default FilterPeopleProfile;
